<template>
  <v-menu v-if="editable && statusOptions && statusOptions.length" offset-y>
    <template #activator="{ on, attrs }">
      <v-chip
        v-bind="attrs"
        v-on="on"
        :color="STATUS_COLOR[status] || 'grey'"
        text-color="white"
        label
        small
        @click="menu = true"
      >
        {{ status }}
      </v-chip>
    </template>
    <v-list>
      <v-list-item v-for="(option, i) in statusOptions" :key="i" @click="selectStatus(option)">
        <v-list-item-title>{{ option.title || option.nombre || option }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-chip v-else :color="STATUS_COLOR[status] || 'grey'" text-color="white" label small>
    {{ status }}
  </v-chip>
</template>

<script>
const STATUS_COLOR = {
  'Evaluación Pendiente': 'error',
  'Evaluación en Proceso': 'info',
  'Evaluación Finalizada': 'success',
}

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      STATUS_COLOR,
      menu: false,
    }
  },

  methods: {
    selectStatus(option) {
      this.$emit('update-status', option)
      this.menu = false
    },
  },
}
</script>
